<template>
  <div class="dynamic-attr-text" :class="(attrObj.isCheckError?'is-check-error':'')">
    <div
      :class="'dynamic-attr-text-title '+ (attrObj.mustFlag=='1'?'is-item-required':'')"
      class="custom-dynamic-attr-text-title"
      :style="{fontSize:$pScreen.titleS}"
    >
      <span>{{ showNum(attrObj, currentPage) }} {{attrObj.title}}</span>
    </div>
    <div
      class="text-item-value"
      :style="{'margin-bottom': attrObj.isCheckError ? '0' : '15px'}"
    >
      <Rate v-if="attrObj.displayType === '1'" :disabled="attrObj.disabled" v-model="attrObj.answerContent" :count="attrObj.maxScore"></Rate>
      <Nps v-else :disabled="attrObj.disabled"  v-model="attrObj.answerContent" :count="attrObj.maxScore"></Nps>
      <div v-if="attrObj.isCheckError" class="errorTip">请选择评分</div>
    </div>
  </div>
</template>


<script>
import Nps from './nps.vue'
import { FormType } from '../../../../commons/commonVariables.js';
export default {
  components: {
    Nps
  },
  props: {
    attrObj: Object,
    currentPage: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      
    }
  },
  created() {},
  //初始化后调用
  mounted: function() {},
  methods: {
    // 只有趣味表单才展示题号
    showNum(item, current){
      if(item.formType !== FormType.interestForm){
        return ''
      } else {
        return `${current + 1}.`
      } 
    },
  }
};
</script>
<style lang="scss">
.dynamic-attr-text {
  width:100%;
}
.text-item-value {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/score.vue